import request from '@/utils/request_python'

export function getMenu() {
  return request({
    url: '/user/menu',
    method: 'get'
  })
}

export function saveMenuByProfile(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data
  })
}
